import type { ReactNode } from 'react';

type MeterProps = {
  value: number;
  label: ReactNode;

  max?: number;
};


export function Meter({ value, label, max }: MeterProps) {
  const pct = Math.min(100, max ? (value / max) * 100 : value);
  const safe = Number.isFinite(pct) ? Math.max(0, pct) : 0;
  const lvl = safe >= 85 ? 'er' : safe >= 65 ? 'wa' : '';
  return (
    <div className={`mbar ${lvl}`.trim()}>
      <div className="track">
        <i style={{ width: `${safe.toFixed(1)}%` }} />
      </div>
      <span>{label}</span>
    </div>
  );
}


export const RefreshIcon = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 11a8 8 0 0 0-13.7-5.7L4 7.5" />
    <path d="M4 4v4h4" />
    <path d="M4 13a8 8 0 0 0 13.7 5.7L20 16.5" />
    <path d="M20 20v-4h-4" />
  </svg>
);
